"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitSelect = void 0;
const react_1 = __importDefault(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const UiKitInput_1 = require("../../components/UiKitInput/UiKitInput");
const lodash_1 = require("lodash");
const consistency_1 = require("../../consistency");
const overrideReactSelectStyleObject = (styles, overrideStyles) => {
    if (!overrideStyles) {
        return styles;
    }
    const styleKeys = Object.keys(styles);
    const overrideStylesWithExistingKeys = (0, lodash_1.pick)(overrideStyles, styleKeys);
    const combinedExistingStyles = (0, lodash_1.mapValues)(overrideStylesWithExistingKeys, (overrideStyle, key) => {
        const styleFn = styles[key];
        if (!overrideStyle) {
            return styleFn;
        }
        const combined = (provided, props) => ({
            ...styleFn(provided, props),
            ...overrideStyle(provided, props),
        });
        return combined;
    });
    return {
        ...styles,
        ...overrideStyles,
        ...combinedExistingStyles,
    };
};
const UiKitSelect = ({ placeholder, isLoading, value, onChange, onValueCleared, options, defaultValue, width, isClearable, isDisabled, styles, ...rest }) => {
    const defaultStyles = {
        control: (base, _) => ({
            ...base,
            ...UiKitInput_1.UiKitInputStyle,
            padding: '0 1px',
            width: width,
        }),
        option: (base, _) => ({
            ...base,
            fontSize: '14px',
        }),
        menu: styles => ({ ...styles, zIndex: 3 }),
        menuPortal: styles => ({ ...styles, zIndex: 1400 }),
        indicatorSeparator: styles => ({
            ...styles,
            display: 'none',
        }),
        groupHeading: () => ({
            borderTop: '2px solid white',
            borderColor: consistency_1.consistency.gray02,
        }),
    };
    const extractOptions = (options) => {
        return options.reduce((acc, current) => {
            if ('options' in current) {
                acc.push(...current.options);
            }
            else {
                acc.push(current);
            }
            return acc;
        }, []);
    };
    const onlyOptions = extractOptions(options);
    return (react_1.default.createElement(react_select_1.default, { classNamePrefix: "select", styles: overrideReactSelectStyleObject(defaultStyles, styles), value: onlyOptions.find(option => option.value === value), defaultValue: defaultValue ? onlyOptions.find(option => option.value === defaultValue) : undefined, options: options, placeholder: placeholder, isLoading: isLoading, isClearable: isClearable ?? true, isDisabled: isDisabled ?? false, isRtl: false, isSearchable: true, onChange: (newValue, { action }) => {
            if (action === 'clear') {
                onValueCleared();
                return;
            }
            onChange(newValue.value);
        }, menuPortalTarget: typeof window !== 'undefined' ? document.body : null, menuPosition: "fixed", menuPlacement: "auto", ...rest }));
};
exports.UiKitSelect = UiKitSelect;
